<template>
    <div class="grid-x align-stretch tab-wrapper">
        <div class="cell large-4 small-12 tab-column tab-left">
            <slot name="header"></slot>
            <div class="tabs">
                <ul class="grid-x large-up-1 medium-up-3 small-up-1">
                    <li v-for="tab in tabs" class="cell">
                        <a :href="tab.href" @click="selectTab(tab)" :class="{ 'active': tab.isActive }">
                            <span class="caption">
                                <span class="image" v-if="tab.image" v-html="tab.imageTag"></span>
                                <span class="heading">{{tab.name}}</span>
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="cell large-8 small-12 tab-items tab-right">
            <slot></slot>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                tabs: []
            }
        },
        created() {
            this.tabs = this.$children;
        },
        methods: {
            selectTab(selectedTab) {
                this.tabs.forEach(tab => {
                    tab.isActive = (tab.name == selectedTab.name)
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/src/components/Tabs/TabsWrapper.vue